import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ProductPlacementCopyBox } from '../../components/product-detail/product-placement-copy-box/productPlacementCopyBox';
import { makeGetPPCForSelectedColorWithId } from '../../redux/product/selectors/ProductSelector';
export const ProductPlacementCopyContainer = ({ ppcType }) => {
    const getPPCPositionsForSelectedColor = makeGetPPCForSelectedColorWithId();
    const items = useSelector((state) => getPPCPositionsForSelectedColor(state, ppcType));
    if (!items) {
        return null;
    }
    return (_jsx(_Fragment, { children: items.map((item) => (_jsx(ProductPlacementCopyBox, { ppc: item }, item.name))) }));
};
